import { useState } from "react";
import type { FactorState } from "../components/organisms/MFACodeContainer";

export function useMFAFlow() {
  const [currentScreen, setCurrentScreen] = useState<"login" | "mfaSelection" | "mfaCode">("login");
  const [selectedFactor, setSelectedFactor] = useState<FactorState | null>(null);
  const [mfaError, setMfaError] = useState<string | null>(null);
  const [mfaErrorCode, setMfaErrorCode] = useState<string | null>(null);
  const [isSelectingFactor, setIsSelectingFactor] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  return {
    currentScreen,
    setCurrentScreen,
    selectedFactor,
    setSelectedFactor,
    mfaError,
    setMfaError,
    mfaErrorCode,
    setMfaErrorCode,
    isSelectingFactor,
    setIsSelectingFactor,
    isVerifying,
    setIsVerifying,
    isResending,
    setIsResending,
    isRedirecting,
    setIsRedirecting,
  };
}
